const formatName = (s) => `${s.firstName}${insertion(s)} ${s.lastName}`;
export const insertion = (s, comma = false) => s.insertion ? (comma ? ", " : " ") + s.insertion : "";
export default formatName;
